import { render, staticRenderFns } from "./IlluParent.vue?vue&type=template&id=1d8bfe77&"
import script from "./IlluParent.vue?vue&type=script&lang=js&"
export * from "./IlluParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports